export default class FormQuizVoiture8 extends HTMLDivElement {

    constructor() {
        super();
        this.budgetRadios = [];
        this.garageRadios = [];
        this.inputBudgetAutre = null;
        this.inputLoyerGarage = null;
    }

    connectedCallback() {
        
        this.budgetRadios = this.querySelectorAll('input[type="radio"][name="budget"]');
        this.garageRadios = this.querySelectorAll('input[type="radio"][name="garage"]');
        this.inputBudgetAutre = this.querySelector('#input-budget-autre');
        this.inputLoyerGarage = this.querySelector('#input-loyer-garage');
        
        this.handleBudgetChange();
        this.handleGarageChange();
        
        this.budgetRadios.forEach(radio => {
            radio.addEventListener('change', () => this.handleBudgetChange());
        });
        
        this.garageRadios.forEach(radio => {
            radio.addEventListener('change', () => this.handleGarageChange());
        });
    }

    handleBudgetChange() {
        const autreRadio = this.querySelector('input[type="radio"][name="budget"][value="autre"]');
        
        if (autreRadio && autreRadio.checked) {
            this.inputBudgetAutre.classList.remove('d-none');
            this.inputBudgetAutre.classList.add('d-flex');
        } else {
            this.inputBudgetAutre.classList.remove('d-flex');
            this.inputBudgetAutre.classList.add('d-none');
        }
    }

    handleGarageChange() {
        const garageOuiRadio = this.querySelector('input[type="radio"][name="garage"][value="1"]');

        if (garageOuiRadio && garageOuiRadio.checked) {
            this.inputLoyerGarage.classList.remove('d-none');
            this.inputLoyerGarage.classList.add('d-flex');
        } else {
            this.inputLoyerGarage.classList.remove('d-flex');
            this.inputLoyerGarage.classList.add('d-none');
        }
    }

}
